import React, { useEffect } from 'react';
import { initMetaPixel, trackPixelEvent } from './utils/metaPixel';
import { AnnouncementBar } from './components/AnnouncementBar';
import { Hero } from './components/Hero';
import { PackContents } from './components/PackContents';
import { Workflow } from './components/Workflow';
import { FitCheck } from './components/FitCheck';
import { Pricing } from './components/Pricing';
import { Reviews } from './components/Reviews';
import { FAQ } from './components/FAQ';
import { ClosingCTA } from './components/ClosingCTA';
import { Disclaimer } from './components/Disclaimer';
import { Footer } from './components/Footer';
import { CURRENCY, PRICE_VALUE, PRODUCT_NAME } from './components/Shared';
export function App() {
  useEffect(() => {
    initMetaPixel();
    trackPixelEvent('ViewContent', {
      content_name: PRODUCT_NAME,
      content_type: 'product',
      value: PRICE_VALUE,
      currency: CURRENCY
    });
  }, []);
  return <div lang="en" className="min-h-screen w-full overflow-x-hidden rice-paper-soft font-sans text-stone-900 antialiased selection:bg-emerald-100 selection:text-emerald-900" data-id="element-0" data-mp="23ti7s3go4sjo">
      <AnnouncementBar data-id="element-1" data-mp="3mjg8pi0yg3km" />
      <main data-id="element-2" data-mp="3rcj6k2crlz6m">
        <Hero data-id="element-3" data-mp="3rbrcivytg9ig" />
        <PackContents data-id="element-4" data-mp="3rdaselgk8ijp" />
        <Workflow data-id="element-5" data-mp="3rd1bdndhtlq5" />
        <FitCheck data-id="element-6" data-mp="3reltgdimfc74" />
        <Pricing data-id="element-7" data-mp="5otf64sd496" />
        <Reviews data-id="element-8" data-mp="67yhm9c7y5s" />
        <FAQ data-id="element-9" data-mp="4n53zyrel9i" />
        <ClosingCTA data-id="element-10" data-mp="5gbv0xpxarn" />
        <Disclaimer data-id="element-11" data-mp="7sulgbavp5r" />
      </main>
      <Footer data-id="element-12" data-mp="2zllcouynw8jk" />
    </div>;
}